import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { NavBar, TabBar } from 'antd-mobile';

const MobileLayout = ({ children }) => (
  <div>
    <NavBar>สารสนเทศคณะสงฆ์ ภาค ๔-๕ (ธ)</NavBar>
    <div style={{ padding: 16 }}><Outlet /></div>
    <TabBar>
      <TabBar.Item key="home" title="หน้าแรก" />
      <TabBar.Item key="setting" title="ตั้งค่า" />
    </TabBar>
  </div>
);

export default MobileLayout;